import React, { Component } from 'react';

import InputButton from './../../../../components/ZUILib/InputButton';
import { reorderFilterIcon } from './reorderEventsIcon';

import commonUtil from '../../../../utils/commonUtil';

const channel = commonUtil.getChannel();
const isWebDevice = channel === 'web';

export class ReorderListBtn extends Component {
  reorderEvents = (typeOrderKey) => {
    const { cleanSearchByUserDetails = () => {}, updateInternalState = () => {} } = this.props;
    updateInternalState();
    if (isWebDevice) this.props.typeOrderFn(); // TODO review this
    cleanSearchByUserDetails();


    // const { firstNameOrNickName = '' } = this.props.dataForEventSearchByUserDetails;
    // if (!firstNameOrNickName) return;

    const hasEventType = this.props.eventType;
    const dataPostService = {
      ...this.props.dataForEventSearchByUserDetails,
      eventDateSort: isWebDevice
        ? this.props.typeOrderProp[typeOrderKey]
        : this.props.typeOrderProp[this.props.typeOrderFn()],
      pageNum: 1,
      eventType: hasEventType,
    };
    this.props.isReorderFn(true);
    this.props.eventSearchByUserDetails(dataPostService);
  }

  render() {
    const { filterTypeEventOrder, typeOrderKey, eventDateSort } = this.props;
    const setLabelOrderFilter = (key) => {
      if (filterTypeEventOrder) return 'cercana';
      return key ? 'lejana' : 'cercana';
    };

    const labelBtnWap = setLabelOrderFilter(typeOrderKey);
    const resultLabel = isWebDevice
      ? `Fecha más ${((typeOrderKey || eventDateSort === 'desc' || !eventDateSort) ? 'cercana' : 'lejana')}`
      : `Fecha más ${labelBtnWap}`;

    const reorderFilter = () => ({
      type: 'button',
      aditionaIcon: reorderFilterIcon,
      value: resultLabel,
      autoFocus: false,
      onClickHandler: () => this.reorderEvents(typeOrderKey),
      cssStyle: {
        border: isWebDevice ? 'solid 1px #d8d8d8' : '1px solid #C0C0C0',
        borderRadius: isWebDevice ? '4px' : '8px',
        background: 'transparent',
        display: 'flex',
        justifyContent: isWebDevice && 'space-between',
        gap: !isWebDevice && '4px',
        width: isWebDevice && '99%',
        alignItems: 'center',
        height: '41px',
      },
    });

    // web layer
    let isClosest = true;
    if (filterTypeEventOrder) {
      isClosest = true;
    } else if (typeOrderKey) {
      // If typeOrderKey is truthy, treat it as "farthest"
      isClosest = false;
    } else if (eventDateSort && eventDateSort !== 'desc') {
      // If an eventDateSort is provided and not 'desc', assume it's "farthest"
      isClosest = false;
    }
    const selectedValue = isClosest ? 'cercana' : 'lejana';  // 'cercana' -> closest, 'lejana' -> farthest

    return (isWebDevice ?(<div className="reorder-select-wrapper">
        {/* Icon on the left side of the dropdown */}
        <span className="reorder-icon">
          {/** Render the sort icon (up/down arrows) **/}
          {reorderFilterIcon}
        </span>
        {/* Native select element for sorting options */}
        <select 
          className="reorder-select"
          value={selectedValue}
          onChange={(e) => {
            const choice = e.target.value;
            // Map the selected value to a typeOrderKey (0 for 'cercana', 1 for 'lejana')
            const newKey = (choice === 'lejana') ? 1 : 0;
            this.reorderEvents(newKey);
          }}
        >
          <option value="cercana">Fecha más cercana al día de hoy</option>
          <option value="lejana">Fecha más lejana al día de hoy</option>
        </select>
      </div>) 
    :<InputButton buttonAttr={reorderFilter()} />);
  }
}
